import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

let heroInit = false;
let heroSwiper;

function initiateHeroSwiper() {
  const heroSlider = document.querySelector('.hero-swiper');

  if (!heroSlider) {
    return;
  }

  const swiperWrapper = heroSlider.querySelector('.swiper-wrapper');
  const slides = heroSlider.querySelectorAll('.swiper-slide');

  if (!swiperWrapper || !slides.length) {
    return;
  }

  if (!heroInit) {
    heroInit = true;
    heroSwiper = new Swiper('.hero-swiper', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 6000,
      },
      a11y: {
        prevSlideMessage: _x(
          'Previous slide',
          'carousel previous button',
          'vtx'
        ),
        nextSlideMessage: _x('Next slide', 'carousel next button', 'vtx'),
        slideRole: false,
        slideLabelMessage: '',
      },
    });
  } else if (heroInit) {
    heroInit = false;
    heroSwiper.update();
  }
}

function handleResize() {
  initiateHeroSwiper();
}

function initiateVideoPlayPause() {
  document
    .querySelectorAll('.hero__background-video-play-pause-icon')
    .forEach((btn) => {
      const hero = btn.closest('.swiper-slide, .hero--home');
      const video = hero ? hero.querySelector('video') : null;

      if (!video) {
        return;
      }

      const iconPause = btn.querySelector('.fa-pause');
      const iconPlay = btn.querySelector('.fa-play');

      iconPlay.style.display = 'none';

      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-label', 'Pause video');
      btn.setAttribute('tabindex', '0');

      function toggle() {
        if (video.paused) {
          video.play();
          iconPause.style.display = '';
          iconPlay.style.display = 'none';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          iconPause.style.display = 'none';
          iconPlay.style.display = '';
          btn.setAttribute('aria-label', 'Play video');
        }
      }

      btn.addEventListener('click', toggle);
    });
}

domReady(() => {
  initiateHeroSwiper();
  initiateVideoPlayPause();
});

window.addEventListener('resize', handleResize);
